import { render, staticRenderFns } from "./QRLayout.vue?vue&type=template&id=8fdac22e"
import script from "./QRLayout.vue?vue&type=script&lang=ts"
export * from "./QRLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports